var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.25C9.98438 2.25 6.79688 4.125 5.01562 7.125C3.28125 10.1719 3.28125 13.875 5.01562 16.875C6.79688 19.9219 9.98438 21.75 13.5 21.75C16.9688 21.75 20.1562 19.9219 21.9375 16.875C23.6719 13.875 23.6719 10.1719 21.9375 7.125C20.1562 4.125 16.9688 2.25 13.5 2.25ZM13.5 24C9.1875 24 5.25 21.75 3.09375 18C0.9375 14.2969 0.9375 9.75 3.09375 6C5.25 2.29688 9.1875 0 13.5 0C17.7656 0 21.7031 2.29688 23.8594 6C26.0156 9.75 26.0156 14.2969 23.8594 18C21.7031 21.75 17.7656 24 13.5 24ZM18.7969 9.79688L12.7969 15.7969C12.3281 16.2656 11.625 16.2656 11.2031 15.7969L8.20312 12.7969C7.73438 12.375 7.73438 11.6719 8.20312 11.25C8.625 10.7812 9.32812 10.7812 9.79688 11.25L12 13.4531L17.2031 8.25C17.625 7.78125 18.3281 7.78125 18.7969 8.25C19.2188 8.67188 19.2188 9.375 18.7969 9.79688Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/_check.0ffabf654b05b8b71a96432ab3ab1d91.svg";
export { ForwardRef as ReactComponent };